module.exports = __webpack_public_path__ + "media/flags/me-f18fdf3e.svg";